module.exports = __webpack_public_path__ + "img/info.bd143100.svg";